import { useState } from 'react';
import { Form } from 'antd';

export const useTableForm = <T>(
  items: T[],
  itemKeyAccessor: (item: T) => string,
  updateItem: (updatedRule: T) => Promise<void>,
) => {
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState<string>();

  const isEditing = (item: T) => itemKeyAccessor(item) === editingKey;
  const cancel = () => setEditingKey(undefined);

  const edit = (item: T) => {
    form.setFieldsValue(item);
    setEditingKey(itemKeyAccessor(item));
  };

  const save = async (initialItem: T) => {
    try {
      const updatedItem = await form.validateFields();

      await updateItem({ ...initialItem, ...updatedItem });
      cancel();

      // eslint-disable-next-line no-empty
    } catch (e) {}
  };

  return { form, isEditing, save, edit, cancel };
};
